export default function initFAQ() {
  document.querySelectorAll(".faq-item").forEach((item) => {
    const answer = item.querySelector(".faq-answer");

    answer.style.maxHeight = "0px";

    item.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      if (isOpen) {
        answer.style.maxHeight = "0px";
      } else {
        answer.style.maxHeight = `${answer.scrollHeight + 20}px`;
      }

      item.classList.toggle("active");
    });
  });
}
